<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1B9QAWu/tc-custom/9781936932320.jpg?1700807482035" alt="This image is the cover for the book You Have the Right to Remain Fat"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">You Have the Right to Remain Fat
      </h1>
      <p class="bookDescription body article font2">
        <b>“In this bold new book, Tovar eviscerates diet culture, proclaims the joyous possibilities of fatness, and shows us that liberation is possible.” —Sarai Walker, author of Dietland</b><br/><br/> Growing up as a fat girl, Virgie Tovar believed that her body was something to be fixed. But after two decades of dieting and constant guilt, she was over it—and gave herself the freedom to trust her own body again.<br/><br/> Ever since, she’s been helping others to do the same. Tovar is hungry for a world where bodies are valued equally, food is free from moral judgment, and you can jiggle through life with respect. In concise and candid language, she delves into unlearning fatphobia, dismantling sexist notions of fashion, and how to reject diet culture’s greatest lie: that fat people need to wait before beginning their best lives.<br/><br/><b>“This book feels like spending a margarita-soaked day at the beach with your smartest friend. Virgie Tovar shares juicy secrets and makes revolutionary ideas viscerally accessible. You’ll be left enlightened, inspired, happier, and possibly angrier than when you started.” —Joy Nash, actress</b><br/><br/><b>“Tovar is a vital voice in contemporary activism, media, and feminism. The joy she takes in her own body and life, combined with the righteous anger she expresses at an oppressive world is a truly radical act. She is deeply thoughtful, but does not equivocate. She confronts bigotry, but does not engage with bullshit.” —Kelsey Miller, author of <i>Big Girl</i><br/><br/><b>“Long-time body positive writer, speaker and activist Virgie Tovar is gifting brown round girls the book we’ve been hungry for.” —Mitú</b></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Virgie Tovar
      </h2>
      
      <p class="authorDescription body article"><P>Virgie Tovar is an author, activist and one of the nation's leading experts and lecturers on fat discrimination and body image. She is the founder of Babecamp, started the hashtag campaign #LoseHateNotWeight, and edited the groundbreaking anthology <I>Hot &amp; Heavy: Fierce Fat Girls on Life, Love and Fashion </I>(Seal Press 2012). Virgie has been featured by the <I>New York Times</I>, MTV, Al Jazeera, NPR, the <I>San Francisco Chronicle</I>, the <I>Huffington Post</I>, <I>Cosmopolitan</I>, and <I>BUST</I>.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The Feminist Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4bdce47f